import React      from 'react';
import ReactDom   from 'react-dom';

import Const      from 'fw_const';
import Utils      from 'utils';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class ProfilingGeneGender extends React.Component {
  render() {
    try {
      let profiling = this.props.profiling;
      
      let data = { '13-17': {}, '18-24': {}, '25-34': {}, '35-44': {}, '45-54': {}, '55-64': {}, '65+': {} };
      
      // データ設定
      let max = 0;
      let json = JSON.parse(profiling);
      for( let i in json ){
        if( i.indexOf('M.') !== -1 ) data[i.replace('M.','')][1] = json[i];
        if( i.indexOf('F.') !== -1 ) data[i.replace('F.','')][2] = json[i];
        
        if( json[i] > max ) max = json[i];
      }
      
      // ループ指標
      let generation = ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'];
      let gender = [1, 2];
      
      return (
        <div className="follower-gene-gender-profiling">
          
          <h5><b>{this.props.title}</b></h5>
          
          <div className="follower-gene-gender-header">
            <h6>年代</h6>
            <p className="man_icon" />
            <p className="woman_icon" />
          </div>
          
          { generation.map((gene, i) => {
            return (
              <div key={i} className="generation">
                <p>{gene}</p>
                {gender.map((gend, j) => {
                  let score   = data[gene][gend];
                  let percent = Math.round((data[gene][gend] / max) * 100);
                  return (
                    <div key={j} className={'gender mode_' + gend}>
                      { (max == score) ? <p className="per"><b>{score}%</b></p> : <p className="per">{score}%</p>}
                      <p className="bar" style={{ width: percent + '%' }} />
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      );
    } catch(e) {
      console.log(e);
      return null;
    }
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProfilingGeneGender;